import Radio from '../radio/radio';
import styles from './index.module.scss';

interface radioItemProps {
  isSupport: boolean;
  isChecked: boolean;
  disabled: boolean;
  id: string;
  title: string;
  desc: string;
  groupName: string;
  onClick: (value: string) => void;
  content: any;
}

const RadioItem = ({
  isSupport = true,
  isChecked = false,
  id,
  title,
  desc,
  groupName,
  onClick,
  content,
  disabled,
}: radioItemProps) => {
  if (!isSupport) return <></>;

  return (
    <div
      className={styles['radio-item']}
      onClick={() => {
        if (!isChecked) onClick(id);
      }}
    >
      <div className={styles['top']}>
        <div className={styles.text}>
          {title}
          {desc && isChecked && <span>{desc}</span>}
        </div>
        <Radio
          isChecked={isChecked}
          id={id}
          name={groupName}
          disabled={disabled}
        />
      </div>
      {content && isChecked && <div className={styles.content}>{content}</div>}
    </div>
  );
};

export default RadioItem;
